<div class="container-fluid mb-4">
  <!--#region liste des onglets clients-->
  <div class="row my-3">
    <input #inputClients type="text" list="clientsDataList"
           name="inputClient" placeholder="Rechercher..."

           class="d-flex mb-0 mr-2 q-input-border"
           style=" width: auto; min-width: min(calc(100% - 30px), 400px);"
           [(ngModel)]="inputClientsValue"
           autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"/>

    <datalist id="clientsDataList">
      <option *ngFor="let cli of clients"
              [value]="cli?.RaisoCli + datalistOptionSplit1 + (cli?.Conventions ? cli.Conventions.length : 0) + datalistOptionSplit2 + cli.CpVille">
    </datalist>

    <button class="btn-icon mr-2" (click)="ClearFilterInput(inputClients)"><i class="fas fa-times q-c-danger"></i></button>
   
    <button class="d-flex ml-md-auto btn-icon" style="text-decoration: underline" (click)="OpenAll()">Voir toutes les conventions</button>
    <button class="d-flex btn-icon mx-2" style="text-decoration: underline" (click)="CloseAll()">fermer toutes</button>
  </div>
  <!--#endregion-->
  <!--#region bloc détail des conventions du client sélectionné-->

  <ng-container *ngFor="let client of ClientFilter(clients, inputClientsValue); let iCli = index">
      <queoval-client-convention [client]="client" [index]="iCli" class="row mb-2"></queoval-client-convention>
  </ng-container>

  <!--#endregion-->
</div>
